module.exports = __webpack_public_path__ + "static/media/lines.507144a0.svg";